import { defineStore } from 'pinia'

import type { OrderStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useOrderStore = defineStore('order', {
  state: (): OrderStore => ({
    order: null,
    changelogPayment: null,
  }),
  actions,
  getters,
})
